/* eslint-disable-next-line */
type SearchFormProps = {
  button?: React.ReactElement;
  className?: string;
  formStyle?: string;
  placeholder?: string;
  value: string;
  handleSearch: (e: string) => void;
  setKeyword: (e: string) => void;
};

export function ManualsSearch(props: SearchFormProps) {
  const {
    button,
    className = 'py-2 px-4 h-full',
    formStyle = 'font-BebasNeue',
    placeholder = 'SEARCH...',
    value,
    handleSearch,
    setKeyword
  } = props;

  return (
    <div className={`${className}`}>
      <input
        className={`py-2 px-4 h-full w-full outline-none ${formStyle}`}
        name="keyword"
        placeholder={placeholder}
        type="text"
        value={value}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyDown={(e) => handleSearch(e.key)}
      />
      {button}
    </div>
  );
}

export default ManualsSearch;
